import type { LambdaWebRevisionSummary } from '@localstack/types';

export const getLatestWebRevision = (
  revisions: LambdaWebRevisionSummary[] = [],
): LambdaWebRevisionSummary | undefined =>
  revisions.reduce<LambdaWebRevisionSummary | undefined>((latest, revision) => {
    const time = revision.createdAt?.getTime() ?? -Infinity;
    const latestTime = latest?.createdAt?.getTime() ?? -Infinity;
    return !latest || time > latestTime ? revision : latest;
  }, undefined);

export const resolveWebFunctionLogGroup = (
  configuredGroup?: string,
  groups: { logGroupName?: string }[] = [],
): string | undefined => {
  if (!configuredGroup) return undefined;
  return (
    groups.find((group) => group.logGroupName === configuredGroup)?.logGroupName ??
    groups.find((group) => group.logGroupName === `${configuredGroup}.local`)?.logGroupName
  );
};
